import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, combineLatest, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { TokenService } from '../services/auth/token.service';
import { AuthService } from '../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class TokenInterceptor implements HttpInterceptor {
  private token$: Observable<string>;
  private token;
  private urls$: Observable<string[]>;
  private urls;
  private matchingUrls: [];
  private authService: AuthService;

  constructor(private tokenService: TokenService, private injector: Injector) {
    this.token$ = tokenService.tokenSubject;
    this.urls$ = tokenService.urlsSubject;
    combineLatest(this.token$, this.urls$).subscribe(values => {
      this.token = values[0];
      this.urls = values[1];
    });
  }

  private getAuthService(): AuthService {
    if (!this.authService) {
      this.authService = this.injector.get(AuthService);
    }
    return this.authService;
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    request = this.token ? this.addHeader(request) : request.clone();
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          const auth = this.getAuthService();
          if (!auth.isValidToken) {
            auth.startAuthentication();
          }
        }
        return throwError(error);
      })
    );
  }

  addHeader(request: HttpRequest<any>) {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${this.token}`,
      },
    });
  }
}
